export default "__VITE_ASSET__qeEK1lZS__"